/** WizardStepType — krok 1/6 kreatora widgetu: wybór typu wizualnego. */

import { useTranslation } from 'react-i18next';
import { BarChart3, Donut, Gauge, LineChart, type LucideIcon, PieChart, Table } from 'lucide-react';

import { Button } from '@/components/Button';
import { WIDGET_VISUAL_TYPES, type WidgetVisualType } from '@/lib/widgets/types';

const TYPE_ICON: Record<WidgetVisualType, LucideIcon> = {
  kpi: Gauge,
  bar: BarChart3,
  pie: PieChart,
  donut: Donut,
  line: LineChart,
  table: Table,
};

export interface WizardStepTypeProps {
  visualType: WidgetVisualType | null;
  onChange: (next: WidgetVisualType) => void;
}

export function WizardStepType({ visualType, onChange }: WizardStepTypeProps) {
  const { t } = useTranslation();
  return (
    <div>
      <p className="mb-3 text-sm text-text-tertiary">
        {t('tenant.widgets.wizard.type.description')}
      </p>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3" data-testid="widget-wizard-type-grid">
        {WIDGET_VISUAL_TYPES.map((type) => {
          const Icon = TYPE_ICON[type];
          const selected = type === visualType;
          return (
            <Button
              key={type}
              type="button"
              variant={selected ? 'primary' : 'secondary'}
              onClick={() => onChange(type)}
              aria-pressed={selected}
              data-testid={`widget-wizard-type-${type}`}
              className="h-auto flex-col p-4"
            >
              <Icon className="h-6 w-6" aria-hidden="true" />
              <span className="text-sm font-medium">{t(`tenant.widgets.visualType.${type}`)}</span>
            </Button>
          );
        })}
      </div>
    </div>
  );
}
